import styles from './Footer.module.scss';

type PrivateProps = {
  mouseCoords?: number[];
};

type FooterLink = {
  id: string;
  url: string;
  label: string;
};

const footerLinks: FooterLink[] = [
  { id: '1', url: 'https://www.dhigroup.com/disclaimer', label: 'Disclaimer' },
  {
    id: '2',
    url: 'https://www.dhigroup.com/terms-of-use',
    label: 'Terms of use',
  },
  { id: '3', url: 'https://www.dhigroup.com/privacy', label: 'Privacy policy' },
  {
    id: '4',
    url: 'https://www.dhigroup.com/cookie-page',
    label: 'Cookie policy',
  },
];

export default function Footer({ mouseCoords }: PrivateProps) {
  return (
    <div className={styles.footer}>
      <div className={`${styles.left}`}>
        <ul className={`${styles.links}`}>
          {footerLinks.map((link) => (
            <li key={link.id}>
              <a href={link.url} target='_blank' rel='noreferrer noopener'>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.center}>
        {mouseCoords && (
          <div className={styles.mouseCoords}>
            {`Longitude [°E], Latitude [°N]: ${mouseCoords?.[0]}, ${mouseCoords?.[1]}`}
          </div>
        )}
      </div>
      <div className={styles.right}>
        <div>
          &copy;{' '}
          <a
            href='https://www.mapbox.com/about/maps'
            target='_blank'
            rel='noreferrer noopener'
          >
            Mapbox
          </a>{' '}
          | &copy;{' '}
          <a
            href='https://www.openstreetmap.org/about/'
            target='_blank'
            rel='noreferrer noopener'
          >
            OpenStreetMap
          </a>
          contributors
        </div>
      </div>
    </div>
  );
}
